import React from 'react';
import PropTypes from 'prop-types';

import { CustomSlate, htmlToSlate } from 'src/components/RichSlate';

import { InstructionsTextarea } from '../InstructionsTextarea';

import { useHandlers } from './useHandlers';

export const InstructionsTextareaWrapper = ({
  className,
  setPlusIconClicked,
  onMenuButtonClick,
  setWasOpened,
  editor,
  value,
  onChange,
  onMenuOpen,
  onCloseMenu,
  classes,
  loadingFreestyleToolContent,
  isSuggestPromptLoading,
  freestyleToolContentId,
  onKeyDown,
  generationTool,
  isSavePopup,
  onEditorFocus,
  setMenuType,
  shortExpanding,
  noTags,
  autoShowMenu,
  placeHolder,
  footerShown,
  promptImages,
  plusButtonRef,
  setPlusButtonRef,
  isFirstField,
  noMinMaxHeight,
  trackingEvents,
  cachedValue,
  onQuickSearchTriggered,
  disabled,
}) => {
  const { handleChange } = useHandlers({
    onChange,
  });

  return (
    <CustomSlate
      editor={editor}
      value={htmlToSlate(value)}
      onChange={handleChange}
    >
      <InstructionsTextarea
        className={className}
        setPlusIconClicked={setPlusIconClicked}
        onMenuButtonClick={onMenuButtonClick}
        setWasOpened={setWasOpened}
        value={value}
        editor={editor}
        onCloseMenu={onCloseMenu}
        classes={classes}
        loadingFreestyleToolContent={loadingFreestyleToolContent}
        isSuggestPromptLoading={isSuggestPromptLoading}
        freestyleToolContentId={freestyleToolContentId}
        onKeyDown={onKeyDown}
        generationTool={generationTool}
        isSavePopup={isSavePopup}
        onEditorFocus={onEditorFocus}
        setMenuType={setMenuType}
        shortExpanding={shortExpanding}
        noTags={noTags}
        autoShowMenu={autoShowMenu}
        placeHolder={placeHolder}
        footerShown={footerShown}
        promptImages={promptImages}
        plusButtonRef={plusButtonRef}
        setPlusButtonRef={setPlusButtonRef}
        isFirstField={isFirstField}
        noMinMaxHeight={noMinMaxHeight}
        onMenuOpen={onMenuOpen}
        trackingEvents={trackingEvents}
        cachedValue={cachedValue}
        onQuickSearchTriggered={onQuickSearchTriggered}
        disabled={disabled}
      />
    </CustomSlate>
  );
};

InstructionsTextareaWrapper.propTypes = {
  className: PropTypes.string,
  setPlusIconClicked: PropTypes.func.isRequired,
  setWasOpened: PropTypes.func.isRequired,
  onMenuButtonClick: PropTypes.func.isRequired,
  editor: PropTypes.shape().isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onMenuOpen: PropTypes.func.isRequired,
  onCloseMenu: PropTypes.func.isRequired,
  classes: PropTypes.shape(),
  loadingFreestyleToolContent: PropTypes.bool,
  isSuggestPromptLoading: PropTypes.bool,
  freestyleToolContentId: PropTypes.string,
  onKeyDown: PropTypes.func.isRequired,
  generationTool: PropTypes.string,
  isSavePopup: PropTypes.bool,
  onEditorFocus: PropTypes.func,
  setMenuType: PropTypes.func.isRequired,
  shortExpanding: PropTypes.bool,
  noTags: PropTypes.bool,
  autoShowMenu: PropTypes.bool,
  placeHolder: PropTypes.string,
  footerShown: PropTypes.bool,
  setPlusButtonRef: PropTypes.shape(),
  plusButtonRef: PropTypes.shape(),
  isFirstField: PropTypes.bool,
  noMinMaxHeight: PropTypes.bool,
  promptImages: PropTypes.shape(),
  trackingEvents: PropTypes.shape(),
  cachedValue: PropTypes.string,
  onQuickSearchTriggered: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
InstructionsTextareaWrapper.defaultProps = {
  className: null,
  value: undefined,
  classes: null,
  loadingFreestyleToolContent: false,
  isSuggestPromptLoading: false,
  freestyleToolContentId: '',
  generationTool: '',
  isSavePopup: false,
  onEditorFocus: null,
  shortExpanding: false,
  noTags: false,
  autoShowMenu: false,
  placeHolder: '',
  footerShown: false,
  setPlusButtonRef: null,
  plusButtonRef: null,
  isFirstField: false,
  noMinMaxHeight: false,
  promptImages: null,
  trackingEvents: null,
  cachedValue: undefined,
  disabled: false,
};
